
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { RallyRound } from '../../lib/models/RallyRound'

@Component({})
export default class SearchFilterDownload extends Vue {
  // search store mapping
  get search () {
    return this.$store.state.SearchFilterOptions.search
  }

  set search (value: string) {
    this.$store.commit('updateSearch', value)
  }

  // rallyId store mapping
  get filterRallyId () {
    return this.$store.state.SearchFilterOptions.rallyId
  }

  set filterRallyId (value: number) {
    this.$store.commit('updateRallyId', value)
  }

  // rallyRoundId store mapping
  get filterRallyRoundId () {
    return this.$store.state.SearchFilterOptions.rallyRoundId
  }

  set filterRallyRoundId (value: number) {
    this.$store.commit('updateRallyRoundId', value)
  }

  /**
   * ID -1 = not loaded
   * ID 0 = All Rallies
   * Otherwise ID = rally__id
   */
  get filterableRallies () {
    return [{ name: 'Alle Rallys', id: 0 }, ...this.allRallies]
  }

  get allRallies () {
    return this.$store.state.Rally.rallies
  }

  /**
   * ID -1 = not loaded
   * ID 0 = All Rounds
   * Otherwise ID = rally_round_id
   */
  get filterableRoundOptions () {
    if (!this.$store.state.LoggedInUser.user.id) {
      return [{ name: '', id: -1, rallyId: -1 }]
    }
    if (this.$store.state.LoggedInUser.user.isAdmin) {
      return [{ name: 'Alle Runden', id: 0, rallyId: -1 }, ...this.allRallyRounds]
    }
    return this.allRallyRounds
  }

  get filterableRoundOptionsFilteredByRally () {
    return this.filterableRoundOptions.filter((rallyRound: RallyRound) => {
      return rallyRound.rallyId === this.filterRallyId
    })
  }

  get allRallyRounds () {
    return this.$store.getters.rallyRounds
  }

  @Watch('filterRallyId')
  onFilterRallyIdChange () {
    this.filterRallyRoundId = this.filterableRoundOptions[0].id
  }
}
